import { render, staticRenderFns } from "./BSelectWithValidation.vue?vue&type=template&id=142487a4&"
import script from "./BSelectWithValidation.vue?vue&type=script&lang=js&"
export * from "./BSelectWithValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports